import React from 'react';
import { AccountProfile, IconProfiles } from '@esg/ui';

export const ManagementAccountProfile: React.FC = () => {
    return (
        <AccountProfile
            label='Izisalon Admin'
            onLogin={() => { }}
            onLogOut={() => { }}
            IconLoggedOut={<IconProfiles.Logout />}
            avatar="/izisalon-favicon.svg"
        />
    );
};
